import { useEffect, useEffectEvent, useState } from 'react'
import { TextField } from '@mui/material'
import PropTypes from 'prop-types'
import { useDebounce } from 'use-debounce'

const LayerName = ({ handleUpdateLayerName, isDisabled, layerName }) => {
    const [itemLayerName, setItemLayerName] = useState(layerName ?? '')

    const handleNameChange = async (event) => {
        const value = event?.target?.value
        setItemLayerName(value)
    }

    const [debouncedItemLayerName] = useDebounce(itemLayerName, 1000)

    // Reads the current prop and callback without re-running when the parent renames the layer.
    const onDebouncedNameSettled = useEffectEvent((name) => {
        if (name !== layerName) {
            handleUpdateLayerName(name)
        }
    })

    useEffect(() => {
        onDebouncedNameSettled(debouncedItemLayerName)
    }, [debouncedItemLayerName])

    return (
        <TextField
            disabled={isDisabled}
            size="small"
            slotProps={{
                htmlInput: {
                    'data-testid': 'drawingdoctordrawer-layers-layername-input',
                },
            }}
            sx={{ width: '100%' }}
            value={itemLayerName}
            variant="outlined"
            onBlur={handleNameChange}
            onChange={handleNameChange}
        />
    )
}

LayerName.propTypes = {
    handleUpdateLayerName: PropTypes.func,
    isDisabled: PropTypes.bool,
    layerName: PropTypes.string,
}

export default LayerName
